module.exports = __webpack_public_path__ + "img/catholic-super-illustration-library_coins-in-hand.5086094a.svg";